import React, { Component } from "react";
import { Modal } from "antd";
import { connect } from "react-redux";
import { closeModal } from "./modalActions";
import DuplicateOrderDetails from "../orderPunching/modal/DuplicateOrderDetails";
class DuplicateOrderDetailsModal extends Component {
  state = {};
  render() {
    const { closeModal, details } = this.props;
    return (
      <Modal
        title="Order Details"
        visible={true}
        onCancel={closeModal}
        onOk={closeModal}
        width="88%"
        centered
      >
        <DuplicateOrderDetails details={details} />
      </Modal>
    );
  }
}
const actions = { closeModal };
const mapStateToProps = state => ({});

export default connect(
  mapStateToProps,
  actions
)(DuplicateOrderDetailsModal);
